/** Debounced click of the hidden Validate Form control after field changes. */
export function triggerFormValidationSoon(delayMs = 200) {
  clearTimeout(window.__knValidateFormSoon);
  window.__knValidateFormSoon = setTimeout(() => {
    const btn = document.getElementById("VALIDATE_FORM_BUTTON");
    if (btn) {
      btn.click();
    }
  }, delayMs);
}
